export const TEMPLATE_VARIABLES = [
  { variable: '<дата>', description: 'дата резерва' },
  { variable: '<время>', description: 'время резерва' },
  { variable: '<название ресторана>', description: 'название ресторана' },
  { variable: '<имя>', description: 'имя и фамилия' },
  { variable: '<сумма предоплаты>', description: 'сумма предоплаты по этому резерву' },
  {
    variable: '<ссылка предоплаты>',
    description: 'ссылка для внесения предоплаты по этому резерву',
  },
];

export const REQUIRED_TEMPLATE_VARIABLES = ['<сумма предоплаты>', '<ссылка предоплаты>'] as const;

export const DEFAULT_WIDGET_MESSAGE =
  'В некоторых случаях мы можем запросить депозит для подтверждения брони. Его сумма будет указана при подтверждении.';

export const DEFAULT_WIDGET_MESSAGE_AUTO =
  'Для завершения бронирования будет необходимо внести депозит. Ссылка для оплаты станет доступна после подтверждения со стороны ресторана';

export const DEFAULT_PREPAY_REQUIRED_TEXT =
  '<название ресторана>. Внесите предоплату <сумма предоплаты> по ссылке: <ссылка предоплаты>';

export const DEFAULT_PREPAY_REMINDER_TEXT =
  '<название ресторана>. Напоминаем, что для подтверждения резерва необходимо внести предоплату <сумма предоплаты> по ссылке: <ссылка предоплаты>';

export const DEFAULT_PREPAY_CANCELLED_TEXT =
  '<название ресторана>. Мы не получили предоплату по вашему резерву. Резерв отменен.';

export const REMINDER_DELAY_MIN = 5;
export const REMINDER_DELAY_MAX = 120;
export const REMINDER_DELAY_INTERVAL = 5;
export const REMINDER_DELAY_EXTRA_INTERVALS = [
  {
    stage: 120,
    step: 15,
  },
  {
    stage: 300,
    step: 30,
  },
  {
    stage: 600,
    step: 60,
  },
];

export const AUTO_CANCEL_DELAY_MIN = 60;
export const AUTO_CANCEL_DELAY_MAX = 1440;
export const AUTO_CANCEL_INTERVAL = 10;
export const AUTO_CANCEL_EXTRA_INTERVALS = REMINDER_DELAY_EXTRA_INTERVALS;

export const WIDGET_MESSAGE_MAX_LENGTH = 512;
export const NOTIFICATION_TEMPLATE_MAX_LENGTH = 512;
export const PREPAY_REQUIRED_TEMPLATE_MAX_LENGTH = 140;

export const AMOUNT_PER_GUEST_MIN = 1;
export const AMOUNT_PER_GUEST_MAX = 99999;

export const MIN_PERSONS = 1;
